const color = {
  mcsdarkblue: "#1a3768",
  mcslightblue: "#27aae1",
  mcsred: "#dd3449"
};

export default color;
